import { Box, Grid } from "@chakra-ui/react"
import { useState } from "react"

const days = [
  { label: "Mon", value: 0 },
  { label: "Tue", value: 1 },
  { label: "Wed", value: 2 },
  { label: "Thu", value: 3 },
  { label: "Fri", value: 4 },
  { label: "Sat", value: 5 },
  { label: "Sun", value: 6 },
]

export default function WorkingDaysSelector({ selectedDays = [], onChange, isRequired = false }) {
  const [selected, setSelected] = useState<number[]>(selectedDays)

  const toggleDay = (value: number) => {
    const updated =
      selected.includes(value)
        ? selected.filter((v) => v !== value)
        : [...selected, value]
    setSelected(updated)
    onChange?.(updated)
  }

  return (
    <Grid
      mt="2"
      templateColumns="repeat(7, 1fr)"
      gap="2"
      w="100%"
    >
      {days.map((day) => (
        <Box
          key={day.value}
          px="3"
          py="2"
          border="1px solid"
          borderColor={selected.length > 0 ? 'gray.300' : isRequired ? 'red.500' : '#CECFD0'}
          borderRadius="md"
          bg={selected.includes(day.value) ? "blue.500" : "white"}
          color={selected.includes(day.value) ? "white" : "gray.600"}
          fontWeight={selected.includes(day.value) ? "bold" : "normal"}
          fontSize="sm"
          textAlign="center"
          cursor="pointer"
          onClick={() => toggleDay(day.value)}
        >
          {day.label}
        </Box>
      ))}
    </Grid>
  )
}
